import { ErrorHandler } from "@angular/core";
import { HTTP_INTERCEPTORS, HttpClient } from "@angular/common/http";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { APP_RESOLVER_PROVIDERS } from "./app.resolver";
import { AppState } from "./app.service";
import "../styles/styles.scss";
import "../styles/headings.css";
import { UserManager } from "./business/managers/user.manager";
import { LocalStorageRepository } from "./datastore/local/localstorage.repository";
import { RemoteRepository } from "./datastore/remote/remote.repository";
import { UserRepository } from "./datastore/repositories/user/user.repository";
import { AuthInterceptor } from "./datastore/remote/auth.interceptor";
import { ErrorHandlerHelper } from "./crossconcern/helpers/errors/errorhandler.helper";
import { GuardHelper } from "./crossconcern/helpers/generic/guard.helper";
import { FormValidatorHelper } from "./crossconcern/helpers/validators/formvalidator.helper";
import * as Sentry from "@sentry/browser";
import { SENTRY_DSN_URL, SENTRY_ENABLED } from "./crossconcern/utilities/properties/base.property";
import { UserRepositoryInterface } from "./datastore/repositories/user/user.interface";
import { RemoteRepositoryInterface } from "./datastore/remote/remote.interface";
import { LocalStorageRepositoryInterface } from "./datastore/local/localstorage.interface";
import { EmployeeManager } from "./business/managers/employee.manager";
import { EmployeeRepositoryInterface } from "./datastore/repositories/employee/employee.interface";
import { EmployeeRepository } from "./datastore/repositories/employee/employee.repository";
import { HttpErrorInterceptor } from "./datastore/remote/error.interceptor";
import { PhotosphereRepositoryInterface } from "./datastore/repositories/photosphere/photosphere.interface";
import { PhotosphereRepository } from "./datastore/repositories/photosphere/photosphere.repository";
import { PhotosphereManager } from "./business/managers/photosphere.manager";
import { PromotionRepositoryInterface } from "./datastore/repositories/promotion/promotion.interface";
import { PromotionRepository } from "./datastore/repositories/promotion/promotion.repository";
import { ProductRepositoryInterface } from "./datastore/repositories/product/product.interface";
import { ProductRepository } from "./datastore/repositories/product/product.repository";
import { NurseryManager } from "./business/managers/nursery.manager";
import { NurseryRepositoryInterface } from "./datastore/repositories/nursery/nursery.interface";
import { NurseryRepository } from "./datastore/repositories/nursery/nursery.repository";
import { MediaRepositoryInterface } from "./datastore/repositories/media/media.interface";
import { MediaRepository } from "./datastore/repositories/media/media.repository";
import { LogManager } from "./business/managers/log.manager";
import { LogRepositoryInterface } from "./datastore/repositories/log/log.interface";
import { LogRepository } from "./datastore/repositories/log/log.repository";
import { BackofficeGuardHelper } from "./crossconcern/helpers/generic/backofficeguard.helper";
// Application wide providers
var APP_PROVIDERS = APP_RESOLVER_PROVIDERS.concat([
    AppState,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: ErrorHandler, useClass: ErrorHandlerHelper },
    GuardHelper,
    BackofficeGuardHelper,
    // Managers
    UserManager,
    EmployeeManager,
    PhotosphereManager,
    NurseryManager,
    LogManager,
    // Repositories
    { provide: LocalStorageRepositoryInterface, useClass: LocalStorageRepository },
    { provide: RemoteRepositoryInterface, useClass: RemoteRepository },
    { provide: UserRepositoryInterface, useClass: UserRepository },
    { provide: EmployeeRepositoryInterface, useClass: EmployeeRepository },
    { provide: PhotosphereRepositoryInterface, useClass: PhotosphereRepository },
    { provide: PromotionRepositoryInterface, useClass: PromotionRepository },
    { provide: ProductRepositoryInterface, useClass: ProductRepository },
    { provide: NurseryRepositoryInterface, useClass: NurseryRepository },
    { provide: MediaRepositoryInterface, useClass: MediaRepository },
    { provide: LogRepositoryInterface, useClass: LogRepository },
    // Helpers
    ErrorHandlerHelper,
    FormValidatorHelper
]);
export function createTranslateLoader(http) {
    return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}
Sentry.init({
    dsn: SENTRY_DSN_URL,
    enabled: JSON.parse(SENTRY_ENABLED)
});
var ɵ0 = (createTranslateLoader);
/**
 * `AppModule` is the main entry point into Angular2's bootstraping process
 */
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0 };
